import React from "react";
import { Chart } from "primereact/chart";

const PieChartComponent = ({ data, title }) => {
  const isDataEmpty =
    !data ||
    !data.datasets ||
    data.datasets.length === 0 ||
    data.datasets.every((dataset) =>
      dataset.data.every((value) => Number(value) === 0)
    );

  const chartOptions = {
    plugins: {
      legend: {
        position: "bottom",
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div
      style={{
        width: "250px",
        height: "250px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {isDataEmpty ? (
        <p style={{ textAlign: "center", fontSize: "14px", color: "#888" }}>
          No Data Available
        </p>
      ) : (
        <div style={{ width: "100%", height: "200px" }}>
          <Chart
            type="pie"
            data={data}
            options={chartOptions}
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      )}
      <p style={{ textAlign: "center", marginTop: "10px" }}>{title}</p>
    </div>
  );
};

export default PieChartComponent;
